import Geocoder from '@/utilities/geocoder'

export default {
  install(Vue, options) {
    Vue.$geocoder = Vue.prototype.$geocoder = new Geocoder(options)
  },
}
